import { render } from "./GhostTabletFormComponent.vue?vue&type=template&id=644af163"
import script from "./GhostTabletFormComponent.vue?vue&type=script&lang=js"
export * from "./GhostTabletFormComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__